const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 800,
    backgroundColor: 'transparent',
    marginTop: '8px',
  },
  listItem: {
    margin: '10px 0',
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid transparent',
    minHeight: 70,
  },
  active: {
    border: '2px solid #0097EF',
    transform: 'scale(1.025, 1.025)',
    '&:hover': { backgroundColor: theme.palette.background.paper },
  },
  rowAction: {
    display: 'flex',
    alignSelf: 'center',
    height: '100%',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/passengersList/PassengersListStyles.js